"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TournamentMatchGameActivityType = void 0;
var TournamentMatchGameActivityType;
(function (TournamentMatchGameActivityType) {
    TournamentMatchGameActivityType["WaitingNextGame"] = "waiting_next_game";
    TournamentMatchGameActivityType["NextGameStart"] = "next_game_start";
    TournamentMatchGameActivityType["GameStart"] = "game_start";
    TournamentMatchGameActivityType["Checkin"] = "check_in";
})(TournamentMatchGameActivityType = exports.TournamentMatchGameActivityType || (exports.TournamentMatchGameActivityType = {}));
//# sourceMappingURL=tournament-match-game-activity-type.js.map